import UserSimple from "@/models/user/UserSimple";
import AddressSimple from "@/models/address/AddressSimple";

export default class UserListEntry extends UserSimple {

	public username!: string;
	public address!: AddressSimple;

}
